import angular from 'angular'
import personalTaxConfigurationCtrl from './personalTaxConfigurationCtrl'
import editConfigurationCtrl from './parameterConfigurationEditCtrl'

const listPage = require('./view/personalTaxConfiguration.html')
const editPage = require('./view/parameterConfigurationEdit.html')

function config($stateProvider) {
  $stateProvider
    .state('system.settingcenter.personalTaxConfiguration', {
      url: '/personalTaxConfiguration',
      template: '<div ui-view></div>',
      title: '个税参数配置',
      abstract: true,
      default: 'system.settingcenter.personalTaxConfiguration.list',
    })
    .state('system.settingcenter.personalTaxConfiguration.list', {
      url: '/list',
      controller: 'personalTaxConfigurationCtrl',
      template: listPage,
    })
    .state('system.settingcenter.personalTaxConfiguration.add', {
      url: '/add',
      controller: 'editConfigurationCtrl',
      template: editPage,
      title: '新增',
    })
    .state('system.settingcenter.personalTaxConfiguration.edit', {
      url: '/edit/:id',
      controller: 'editConfigurationCtrl',
      template: editPage,
      title: '编辑',
    })
}
export default angular
  .module('system.settingcenter.personalTaxConfiguration', [])
  .config(['$stateProvider', config])
  .controller('editConfigurationCtrl', editConfigurationCtrl)
  .controller('personalTaxConfigurationCtrl', personalTaxConfigurationCtrl).name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/personalTaxConfiguration/index.js